// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3859":"049da83a4e2de252","8007":"4d6ce66f26936026"}[chunkId] + ".js";
};